export default __webpack_public_path__ + "static/media/ampturn.bde0784e.webp";